import SvgIcon from '@mui/material/SvgIcon';

const NightIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_8023_1420)">
                    <path
                        d="M18.6603 20.333C17.4623 21.0247 16.2052 21.4473 14.889 21.601C13.5728 21.7547 12.3 21.6668 11.0706 21.3374C9.8412 21.008 8.69499 20.4477 7.632 19.6565C6.569 18.8653 5.69167 17.8708 5 16.6728C4.30833 15.4748 3.88566 14.2177 3.73199 12.9015C3.57832 11.5853 3.6662 10.3125 3.99562 9.08313C4.32505 7.8537 4.88534 6.70749 5.6765 5.6445C6.46767 4.5815 7.46225 3.70417 8.66025 3.0125C9.16544 2.72083 9.69978 2.47969 10.2633 2.28906C10.8268 2.09842 11.3978 1.97081 11.9764 1.90622C12.1913 1.87839 12.3858 1.91525 12.5599 2.0168C12.734 2.11836 12.8668 2.24852 12.9585 2.40729C13.0335 2.5372 13.0791 2.67447 13.0952 2.8191C13.1114 2.96374 13.0867 3.11269 13.0212 3.26596C12.4692 4.64315 12.2523 6.06743 12.3705 7.5388C12.4887 9.01016 12.9186 10.3882 13.6603 11.6728C14.4103 12.9718 15.3856 14.0445 16.5863 14.8909C17.787 15.7372 19.1248 16.2543 20.5996 16.442C20.7651 16.462 20.9085 16.5187 21.0298 16.6122C21.1512 16.7058 21.2494 16.8175 21.3244 16.9474C21.416 17.1061 21.4623 17.2863 21.4632 17.4879C21.4641 17.6894 21.3988 17.8763 21.2672 18.0484C20.922 18.5172 20.5275 18.9422 20.0837 19.3235C19.6399 19.7048 19.1654 20.0413 18.6603 20.333Z"
                        fill={props.isopen === 'true' ? 'black' : 'white'}
                        fillOpacity={props.isopen === 'true' ? 0.56 : 1}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_8023_1420">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );
};

export default NightIcon;
